import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'

export interface SponsorshipVoucherFormData {
  voucherCode: string
}

export const useSponsorshipVoucherForm = () => {
  const { t } = useTranslation('auth-components')

  const schema = yup.object().shape({
    voucherCode: yup
      .string()
      .required(t('sponsorshipVoucherFormModal.voucherCode.required')),
  })

  return useForm<SponsorshipVoucherFormData>({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(schema),
  })
}
